import { ReactNode } from 'react';
import { createContext } from 'react';
import { useState } from 'react';

type LayoutContextType = {
  navbarCollapsed: boolean;
  setNavbarCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};

type LayoutContextProviderProps = {
  children: ReactNode;
};

const LayoutContext = createContext<LayoutContextType>({} as LayoutContextType);

const LayoutContextProvider = ({ children }: LayoutContextProviderProps) => {
  const [navbarCollapsed, setNavbarCollapsed] = useState(false);

  return (
    <LayoutContext.Provider
      value={{
        navbarCollapsed,
        setNavbarCollapsed
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export { LayoutContext, LayoutContextProvider };
